
import { dateFormatMixin } from '../../mixins'

export default {
  mixins: [dateFormatMixin],
  props: {
    publication: {
      type: Object,
      default: null,
    },
  },
  data () {
    return {
      likes: null,
    }
  },
  async fetch () {
    try {
      if (this.publication?.id) {
        const {
          data: { item: { likes = 0 } = {} } = {},
        } = await this.$api.songs.getAllNested(
          "likes",
          this.publication?.id,
          )
        this.likes = likes || null
      }
    } catch(error) {
      this.$log.warn(error)
    }
  },
  computed: {
    cardProps () {
      return {
        image: this.image,
        title: this.title,
        to: this.to,
        subtitleIcon: this.subtitleIcon,
        subtitle: this.subtitle,
      }
    },
    image() {
      return this.publication?.hero || 'https://nederlandzingt-eo.cdn.eo.nl/{format}/1iuv2gkferxr-fallback-afbeelding.png'
    },
    isImageFull () {
      return this.$attrs['image-full'] || this.$attrs['image-full'] === ''
    },
    isNew () {
      return this.dateFormat.daysInPast(this.publication.publishOn) <= 10
    },
    subtitleIcon () {
      return this.isNew ? 'alert' : null
    },
    subtitle () {
      return this.isNew ? 'Nieuw' : null
    },
    title () {
      return this.publication?.title
    },
    to () {
      if (!this.publication) return null
      return `/liederen/lied/${this.publication.slug}`
    },
  },
}
